module.exports = __webpack_public_path__ + "img/video-title-zh.03caa61a.png";